// InfoField — a small label over a value, the cell of every detail page's info grid.
import type { ReactNode } from "react";

export default function InfoField({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div>
      <p className="text-xs text-dm-slate">{label}</p>
      <div className="text-dm-navy">{children}</div>
    </div>
  );
}
